<template>
  <el-card shadow="never" class="section-nav-card">
    <el-tabs :model-value="activePath" @tab-change="go">
      <el-tab-pane
        v-for="item in sections"
        :key="item.path"
        :label="item.label"
        :name="item.path"
      />
    </el-tabs>
  </el-card>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const sections = [
  { label: '할당현황', path: '/leave/admin/quota' },
  { label: '일괄할당', path: '/leave/admin/bulk' },
  { label: '휴가유형', path: '/leave/admin/types' },
  { label: '신청내역', path: '/leave/admin/requests' },
  { label: '변경이력', path: '/leave/admin/audit' },
]

const activePath = computed(() => {
  if (route.path === '/leave/admin') return '/leave/admin/quota'
  return route.path
})

const go = async (path) => {
  if (route.path === path || (route.path === '/leave/admin' && path === '/leave/admin/quota')) return
  await router.push(path)
}
</script>

<style scoped>
.section-nav-card {
  border: 1px solid #e5e7eb;
}
</style>
